import { render } from "./webread.vue?vue&type=template&id=194352bf"
import script from "./webread.vue?vue&type=script&lang=js"
export * from "./webread.vue?vue&type=script&lang=js"

import "./webread.vue?vue&type=style&index=0&id=194352bf&lang=css"

import exportComponent from "/Volumes/work/mywork/selecthouse/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__